import { CreateFileUploadPayload } from 'api';
import axios from 'axios';
import { useCreateFile } from 'api/graphql/hooks/files/useCreateFile';

export const useGetFileToken = () => {
    const { createFile } = useCreateFile();

    const getToken = async (file: File) => {
        const { size, name } = file;
        const { data, error } = await createFile({
            fileSize: size,
            fileName: name,
        });

        if (error) {
            throw error;
        }

        const { fields, url, uploadToken } = data?.createFileUpload as CreateFileUploadPayload;

        const formData = new FormData();

        for (const { key, value } of fields) {
            formData.append(key, value);
        }
        formData.append('file', file);
        await axios.post(url, formData);

        return uploadToken;
    };

    return {
        getToken,
    };
};
